/**
 * StatsCard Component
 * 
 * Reusable stats card for displaying metrics with icon and trend indicator
 */

import { FC } from 'react';
import { LucideIcon, ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export interface StatsCardProps {
    title: string;
    value: string;
    subtitle: string;
    icon: LucideIcon;
    trend?: 'up' | 'down' | 'neutral';
    className?: string;
}

export const StatsCard: FC<StatsCardProps> = ({ 
    title, 
    value, 
    subtitle, 
    icon: _Icon, 
    trend = 'neutral',
    className = ''
}) => {
    return (
        <Card className={`bg-slate-900 border-slate-700 ${className}`}>
            <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-slate-400">{title}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-3xl font-bold text-white mb-1">{value}</div>
                <p className="text-sm text-slate-500 flex items-center gap-1">
                    {trend === 'up' && <ArrowUpRight className="w-4 h-4 text-emerald-500" />}
                    {trend === 'down' && <ArrowDownRight className="w-4 h-4 text-red-500" />}
                    {subtitle}
                </p>
            </CardContent>
        </Card>
    );
};
